<template>
  <div>
    <base-instance-selection
      :headerInfo="headerInfo"
      :buttonText="buttonText"
      :buttonId="buttonId"
      :headers="headers"
      :rows="getLoanTypeData"
      @selectfilteredMenu="selectfilteredMenu"
      :loanCategories="loanCategories"
      @compare="compareSelectedInvestments"
      @createNew="createNewInvestment"
      @rowSelected="onSelectedInvestment"
      @duplicateRow="duplicateRow"
      @renameRow="renameRow"
      @deleteRow="deleteRow"
      :actionButtonText="actionButtonText"
      :imagepath="imagepath"
    >
    </base-instance-selection>
    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="genericMethodClick"
    >
      <template #dialogBody v-if="!userInputText.isHide">
        <mds-input
          autocomplete="off"
          :label="''"
          v-model="userInputText.value"
          :error="userInputText.isError"
          :errorText="userInputText.errorText"
          :maxlength="maxValue"
        ></mds-input>
        <span>{{ userEnterCharCount }}/{{ maxValue }}</span></template
      >
    </confirmation-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { BaseInstanceSelection } from "../../component/loanSelection";
import { ConfirmationDialog } from "../../component/tool";
import MdsInput from "@mds/input";
import {
  DialogAction,
  EntityTypes,
  InvestmentTypeMapping,
} from "../../helpers/constant";
import Investment from "../../models/investment";
import RiskProfile from "../../models/riskprofiles";
import { InvestmentService } from "../../services";
import { CommonHelper } from "../../helpers";
import {
  SET_INVESTMENT_INFORMATION,
  GET_AUTH_INFORMATION,
  GET_CLIENT_INFORMATION,
  GET_INVESTMENT_INFORMATION,
  SET_RISK_PROFILE_DATA,
  GET_RISK_PROFILE_DATA,
  SET_SELECTED_INVESTMENT_INFORMATION,
  SET_INVESTMENT_DEFAULT_MODEL,
  SET_LOADER_VISIBILITY,
  SET_COMPARE_INVESTMENTS_INFO,
  SET_NOTIFICATION_SUMMARY,
  SET_ALL_INVESTMENT_INFORMATION,
} from "../../helpers/vuex-constants";
import {
  InvestmentSelected,
  CompareAction,
  tabCreatedAction,
  tabSelectedAction,
  DuplicateAction,
  RenameAction,
  DeleteAction,
} from "../../helpers/userEvent";
import { InvestmentClass } from "../../helpers/constant";
import { ToolSelection, UserEvent } from "../../mixin";
export default {
  name: "investment-instance-Selection",
  components: {
    BaseInstanceSelection,
    ConfirmationDialog,
    MdsInput,
  },
  mixins: [ToolSelection, UserEvent],
  data() {
    return {
      headerInfo: {
        heading:
          "Select existing or create new instance from the engagement tools",
        headingIconText: "Click action button for other options",
        subHeading: "Select checkbox to start compare instances",
      },
      buttonText: "Create New Instance",
      buttonId: "investmentCreateNewbtn",
      actionButtonText: "Action",
      maxValue: 60,
      userInputText: {
        value: "",
        isError: false,
        errorText: [],
        isHide: false,
        id: 0,
        payload: {},
      },
      headers: [
        {
          fieldType: "checkbox",
          fieldName: "isSelected",
          style: { width: "45px" },
        },
        {
          text: "Instance Name",
          fieldType: "metadata",
          fieldDescription: "description",
          split: " ",
          metadata: [
            {
              heading: "Balance",
              key: "amount",
            },
            {
              heading: "Income",
              key: "incomeRatePer",
            },
            {
              heading: "Growth",
              key: "growthRatePer",
            },
            {
              heading: "Franking",
              key: "frankedRatePer",
            },
            {
              heading: "Fee",
              key: "feeAmount",
            },
          ],

          styleRow: { "padding-left": "4px" },
        },
        {
          text: "",
          fieldType: "tag",
          fieldAmount: "",
          fieldText: "",
          fieldDescription: "",

          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
        {
          text: "",
          fieldType: "profile",
          fieldAmount: "",
          fieldText: "",
          fieldDescription: "",
          style: { width: "70px" },
          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
        {
          text: "Last Modified",
          fieldType: "date",
          fieldAmount: "",
          fieldText: "text",
          fieldDescription: "",
          fieldName: "date",
          align: "right",
          sortable: true,
          sorted: 1,
          style: { width: "100px" },
          styleRow: { "vertical-align": "middle" },
        },
        {
          text: "",
          fieldType: "action",
          fieldAmount: "",
          fieldText: "text",
          fieldDescription: "",
          style: { opacity: "0px", width: "100px" },
          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
      ],
      rows: {
        type: Array,
      },
      selectedValue: "",

      confirmationDialogList: [
        {
          toggle: false,
          id: 1,
          title: "Discard Changes",
          rightButtons: [
            {
              text: "Cancel",
              variation: "secondary",
              emitevent: "cancel_Click",
              id: 1,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "submit_Click",
              id: 3,
            },
          ],
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      setInvestmentInformation: SET_INVESTMENT_INFORMATION,
      setRiskProfileData: SET_RISK_PROFILE_DATA,
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    ...mapActions("investment", {
      setSelectedInvestmentInfo: SET_SELECTED_INVESTMENT_INFORMATION,
      setInvestmentDefaultModel: SET_INVESTMENT_DEFAULT_MODEL,
      setCompareInvestmentsInfo: SET_COMPARE_INVESTMENTS_INFO,
      setAllInvestmentInformation: SET_ALL_INVESTMENT_INFORMATION,
    }),

    async mapData() {
      let clid = this.getAuthInformation.encClientId;
      this.setLoaderVisibility(true);
      let investmentapiParams = {
        clientId: clid,
        entityType: "1,2,6",
      };
      let setInvestmentInfo =
        this.setInvestmentInformation(investmentapiParams);
      await this.setRiskProfileData(this.getAuthInformation);
      await setInvestmentInfo;
      this.setLoaderVisibility(false);
      let riskdata = this.getRiskProfileData.defaultriskprofiles;
      this.removeEmptyInvestmentInfo();
      let parentClientInfo = this.clientInformation.findIndex(
        (sr) => sr.entityType == EntityTypes.client
      );
      let partnerClientInfo = this.clientInformation.findIndex(
        (sr) => sr.entityType == EntityTypes.partner
      );
      let arr = this.getInvestmentInformation.map((r) => {
        let p = {};
        p.clientId = r.clientId;
        p.ownerId = r.ownerId;
        p.platformid = r.platformid;
        p.description =
          r.description == null
            ? InvestmentClass[r.investmentClassID]
            : r.description;
        p.amount = CommonHelper.convertIntoCurrencyWithoutDecimal(r.amount);
        p.ownerEntityType = r.ownerEntityType;
        p.investmentClassID = r.investmentClassID;
        p.investmentGuid = r.investmentGuid;
        p.frankedRate = CommonHelper.convertAmountIntoDecimalFormat(
          r.frequencyId != 0
            ? r.frankingRate
            : RiskProfile.getRiskProfileValue(
                riskdata,
                r.clientId,
                r.ownerId,
                r.ownerEntityType,
                "frankingRate"
              )
        );
        p.frankedRatePer = p.frankedRate + "%";
        p.growthRate = CommonHelper.convertAmountIntoDecimalFormat(
          r.frequencyId != 0
            ? r.growthRate
            : RiskProfile.getRiskProfileValue(
                riskdata,
                r.clientId,
                r.ownerId,
                r.ownerEntityType,
                "growthRate"
              )
        );
        p.growthRatePer = p.growthRate + "%";
        p.incomeRate = CommonHelper.convertAmountIntoDecimalFormat(
          r.frequencyId != 0
            ? r.incomeRate
            : RiskProfile.getRiskProfileValue(
                riskdata,
                r.clientId,
                r.ownerId,
                r.ownerEntityType,
                "incomeRate"
              )
        );
        p.incomeRatePer = p.incomeRate + "%";
        p.riskProfileId =
          r.frequencyId != 0
            ? RiskProfile.getRiskProfileId(
                this.getRiskProfileData.data,
                r.riskProfileId
              )
            : RiskProfile.getRiskProfileValue(
                riskdata,
                r.clientId,
                r.ownerId,
                r.ownerEntityType,
                "profileId"
              );

        p.isFromFact = r.isExisting ? "FactFind" : "";
        p.isSelected = false;
        p.name = r.name;
        p.investmentGuid = r.investmentGuid;
        p.platformId = r.platformId;
        p.feeAmount = 0;
        p.profiles = this.getProfileName(
          r.ownerEntityType,
          r.clientName,
          partnerClientInfo,
          parentClientInfo
        );
        p.entityName = r.clientName;
        p.date = r.date;
        p.tagName = InvestmentClass[r.investmentClassID];
        p.actionButtons = this.getActionButton(r.isExisting);

        return p;
      });

      this.rows = arr;
    },

    getActionButton(isExisting) {
      let actionButtons = [];
      actionButtons.push({
        emitevent: "duplicateRow",
        icon: "group",
        text: "Duplicate",
        id: 1,
      });
      if (!isExisting) {
        actionButtons.push({
          emitevent: "renameRow",
          icon: "pencil",
          text: "Rename",
          id: 2,
        });
        actionButtons.push({
          emitevent: "deleteRow",
          icon: "trash",
          text: "Delete",
          id: 3,
        });
      }
      return actionButtons;
    },
    duplicateRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = false;
      this.userInputText.id = DialogAction.Duplicate;
      this.userInputText.payload = data;
      if (data) {
        if (data.description.length >= this.maxValue)
          this.userInputText.value =
            "Copy of " +
            data.description.substring(0, this.maxValue - 8) +
            "...";
        else this.userInputText.value = "Copy of " + data.description;
        this.confirmationDialogList[0].title =
          "Duplicate " +
          data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      }
      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Duplicate";
    },
    resetDialogField() {
      this.userInputText = {
        value: "",
        isError: false,
        errorText: [],
        isHide: false,
        id: 0,
      };
    },
    renameRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = false;
      this.userInputText.id = DialogAction.Rename;
      if (data) {
        this.userInputText.payload = data;
        this.confirmationDialogList[0].title =
          "Rename " +
          data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      }
      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Rename";
    },
    deleteRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = true;
      this.userInputText.id = DialogAction.Delete;
      if (data) {
        this.userInputText.payload = data;

        this.confirmationDialogList[0].title =
          "Delete " +
          data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      }
      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Delete";
    },

    submit_Click() {
      if (this.userInputText.id == DialogAction.Delete) {
        this.deleteInvestment(
          this.userInputText.payload.investmentGuid,
          this.userInputText.payload.description,
          this.getAuthInformation.encClientId
        );
      } else if (
        this.userInputText.id == DialogAction.Duplicate &&
        this.validateUserInput()
      ) {
        this.copyInvestment(
          this.userInputText.payload.investmentGuid,
          this.userInputText.value
        );
      } else if (
        this.userInputText.id == DialogAction.Rename &&
        this.validateUserInput()
      ) {
        this.renameInvestment(
          this.userInputText.payload.investmentGuid,
          this.userInputText.value,
          this.getAuthInformation.encClientId
        );
      }
    },
    async copyInvestment(investmentGuid, description) {
      let selectedInvestment = Object.assign(
        {},
        this.getInvestmentInformation.filter(
          (sr) => sr.investmentGuid == investmentGuid
        )[0]
      );
      selectedInvestment.description = description;
      selectedInvestment.isExisting = false;
      let investmentModel = this.createSaveInvestmentModel(selectedInvestment);
      this.setLoaderVisibility(true);
      let response = await InvestmentService.createCopyOfInvestment(
        investmentModel
      );
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Investment instance ${description} has been added.`
        );
        let apiResponse = [];
        response.data.maturityDate = CommonHelper.convertDateToMonthYear(
          response.data.maturityDate
        );
        this.resetAdvanceDetailsDate(response.data);
        apiResponse.push(response.data);
        let copyInvestment = Investment.setInvestmentInformation(
          apiResponse,
          this.clientInformation
        );

        this.getInvestmentInformation.splice(0, 0, copyInvestment[0]);
        this.setAllInvestmentInformation(this.getInvestmentInformation);
        this.mapData();
        this.saveUserSession(InvestmentSelected, DuplicateAction, "");
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to create copy of the ${description} instance .`
        );
      }
    },
    resetAdvanceDetailsDate(investmentModel) {
      if (
        investmentModel &&
        investmentModel.advancedetails &&
        investmentModel.advancedetails.length > 0
      ) {
        for (let i = 0; i < investmentModel.advancedetails.length; i++) {
          investmentModel.advancedetails[i].startDate =
            CommonHelper.convertDateToMonthYear(
              investmentModel.advancedetails[i].startDate
            );
          investmentModel.advancedetails[i].endDate =
            CommonHelper.convertDateToMonthYear(
              investmentModel.advancedetails[i].endDate
            );
        }
      }
    },
    async renameInvestment(investmentGuid, description, encClientId) {
      let fieldInfo = {
        ID: investmentGuid,
        Value: description,
        encClientId: encClientId,
      };
      this.setLoaderVisibility(true);
      let response = await InvestmentService.updateInvestment(fieldInfo);
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Investment instance ${description} has been updated.`
        );
        let selectedInvestmentIndex = this.getInvestmentInformation.findIndex(
          (sr) => sr.investmentGuid == investmentGuid
        );

        this.getInvestmentInformation[selectedInvestmentIndex].description =
          description;
        this.getInvestmentInformation[selectedInvestmentIndex].updatedDate =
          new Date().toISOString().slice(0, 10);
        this.getInvestmentInformation.splice(
          0,
          0,
          this.getInvestmentInformation[selectedInvestmentIndex]
        );
        this.getInvestmentInformation.splice(selectedInvestmentIndex + 1, 1);
        this.setAllInvestmentInformation(this.getInvestmentInformation);
        this.mapData();
        this.saveUserSession(InvestmentSelected, RenameAction, "");
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to rename the ${description} instance .`
        );
      }
    },
    async deleteInvestment(investmentGuid, description, encClientId) {
      this.setLoaderVisibility(true);
      let response = await InvestmentService.deleteInvestment(
        investmentGuid,
        encClientId
      );
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Investment instance ${description} has been deleted.`
        );
        let selectedInvestmentIndex = this.getInvestmentInformation.findIndex(
          (sr) => sr.investmentGuid == investmentGuid
        );

        this.getInvestmentInformation.splice(selectedInvestmentIndex, 1);
        this.setAllInvestmentInformation(this.getInvestmentInformation);
        this.mapData();
        this.saveUserSession(InvestmentSelected, DeleteAction, "");
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to delete the ${description} instance .`
        );
      }
    },

    setNotificationMessage(variation, message) {
      this.setNotificationSummary({
        isShow: true,
        variation: variation,
        text: message,
      });
    },
    validateUserInput() {
      let inputText = this.userInputText.value;
      if (!inputText) {
        return this.setErrorMessage();
      }
      let index = this.rows.findIndex(
        (sr) =>
          sr.description.toLowerCase() == this.userInputText.value.toLowerCase()
      );
      if (index >= 0) {
        return this.setErrorMessage(
          "The instance name is already taken, Use a different name to continue."
        );
      }
      return true;
    },
    setErrorMessage(errorText) {
      this.userInputText.isError = true;
      this.userInputText.errorText = [];
      this.userInputText.errorText.push(errorText);
      this.confirmationDialogList[0].toggle = true;
      return false;
    },
    cancel_Click() {
      this.confirmationDialogList[0].toggle = false;
    },
    createNewInvestment() {
      this.openBasicInvestmentForm();
    },
    createSaveInvestmentModel(selectedInvestment) {
      let investmentModel = {};
      investmentModel.clientId = selectedInvestment.clientId;
      investmentModel.ownerId = selectedInvestment.ownerId;
      investmentModel.investmentID = 0;
      investmentModel.description = selectedInvestment.description;
      investmentModel.contributionAmount =
        selectedInvestment.contributionAmount;
      investmentModel.frequencyId = selectedInvestment.durationTypeId;
      investmentModel.ownerEntityType = selectedInvestment.ownerEntityType;
      investmentModel.frankedRate = selectedInvestment.frankingRate;
      investmentModel.growthRate = selectedInvestment.growthRate;
      investmentModel.incomeRate = selectedInvestment.incomeRate;
      investmentModel.platformid = selectedInvestment.platformId;

      investmentModel.investmentGuid = selectedInvestment.investmentGuid;
      investmentModel.parentInvestmentGuid =
        selectedInvestment.parentInvestmentGuid;
      investmentModel.projectionYear = selectedInvestment.projectionYear;
      investmentModel.investmentAmount = selectedInvestment.amount;
      investmentModel.investmentID = 0;
      investmentModel.isDRP = selectedInvestment.isDRP;
      investmentModel.riskProfileId = selectedInvestment.riskProfileId;
      investmentModel.investmentClassID = selectedInvestment.investmentClassID;
      investmentModel.isRenewAuto = selectedInvestment.isRenewAuto;
      investmentModel.maturityDate = selectedInvestment.maturityDate;
      investmentModel.advancedetails = selectedInvestment.advancedetails;
      investmentModel.isExisting = selectedInvestment.isExisting;
      investmentModel.userId = this.loginUserInfo.adviserId;
      return investmentModel;
    },
    openBasicInvestmentForm() {
      let parentClientIndex = this.clientInformation.findIndex(
        (sr) => sr.entityType == 1
      );
      if (parentClientIndex >= 0) {
        let investmentModel = Investment.getEmptyInvestmentModel(
          this.clientInformation[parentClientIndex]
        );
        this.getInvestmentInformation.splice(0, 0, investmentModel);
        this.setInvestmentDefaultModel(this.getInvestmentInformation);
        this.setSelectedInvestmentInfo(Object.assign({}, investmentModel));
        this.saveUserSession(
          InvestmentSelected,
          tabCreatedAction,
          CompareAction
        );
        this.$router.push({ name: "investment-engagement-tool" });
      }
    },
    removeEmptyInvestmentInfo() {
      if (this.getInvestmentInformation) {
        for (let i = 0; i < this.getInvestmentInformation.length; i++) {
          if (
            this.getInvestmentInformation[i] &&
            this.getInvestmentInformation[i].investmentGuid ==
              "00000000-0000-0000-0000-000000000000"
          )
            this.getInvestmentInformation.splice(i, 1);
        }
      }
    },
    compareSelectedInvestments(data) {
      let userSelectedInvestments = [];
      for (let i = 0; i < data.length; i++) {
        let selectedInvestments = this.getInvestmentInformation.filter(
          (sr) => sr.investmentGuid == data[i].investmentGuid
        );
        if (selectedInvestments && selectedInvestments.length > 0)
          selectedInvestments[0].riskProfileId = data[i].riskProfileId;
        selectedInvestments[0].incomeRate = data[i].incomeRate;
        selectedInvestments[0].growthRate = data[i].growthRate;
        selectedInvestments[0].description = data[i].description;
        selectedInvestments[0].frankingRate = data[i].frankedRate;
        userSelectedInvestments.push(selectedInvestments[0]);
      }
      this.setInvestmentDefaultModel();
      this.setCompareInvestmentsInfo(userSelectedInvestments);
      this.saveUserSession(
        InvestmentSelected,
        CompareAction,
        userSelectedInvestments.length + ""
      );
      this.$router.push({ name: "compare-investment" });
    },
    onSelectedInvestment(rowData) {
      let selectedInvestmentInfo = [];
      if (rowData)
        selectedInvestmentInfo = this.getInvestmentInformation.filter(
          (sr) => sr.investmentGuid == rowData.investmentGuid
        );
      if (selectedInvestmentInfo && selectedInvestmentInfo.length > 0) {
        selectedInvestmentInfo[0].riskProfileId = rowData.riskProfileId;
        selectedInvestmentInfo[0].incomeRate = rowData.incomeRate;
        selectedInvestmentInfo[0].growthRate = rowData.growthRate;
        selectedInvestmentInfo[0].description = rowData.description;
        selectedInvestmentInfo[0].frankingRate = rowData.frankedRate;
        let investmentModel = Object.assign({}, selectedInvestmentInfo[0]);
        this.setInvestmentDefaultModel();

        this.setSelectedInvestmentInfo(investmentModel);
        this.saveUserSession(
          InvestmentSelected,
          tabSelectedAction,
          investmentModel.isExisting ? "FactFind" : ""
        );
        this.$router.push({ name: "investment-engagement-tool" });
      }
    },
    genericMethodClick(function_name) {
      this[function_name]();
    },
    selectfilteredMenu(data) {
      this.selectedValue = data.value;
    },
    GetMenuObject(value, active, text) {
      return {
        value: value,
        active: value == active,
        text: text,
      };
    },
  },
  computed: {
    userEnterCharCount() {
      if (!this.userInputText.value) {
        return 0;
      } else {
        var spaceCount = this.userInputText.value.match(/^\s*/)[0].length;
        spaceCount = spaceCount < 0 ? 0 : spaceCount;

        if (this.userInputText.value.length > this.maxValue) {
          return this.maxValue;
        } else {
          return this.userInputText.value.length - spaceCount;
        }
      }
    },
    imagepath() {
      return require("../../assets/icons/Search.svg");
    },
    ...mapGetters({
      getAuthInformation: GET_AUTH_INFORMATION,
      clientInformation: GET_CLIENT_INFORMATION,
      getRiskProfileData: GET_RISK_PROFILE_DATA,
      loginUserInfo: GET_AUTH_INFORMATION,
    }),
    ...mapGetters("investment", {
      getInvestmentInformation: GET_INVESTMENT_INFORMATION,
    }),
    getLoanTypeData() {
      let selectedLoanType = [];
      if (this.selectedValue == "") {
        return this.rows;
      } else if (this.selectedValue == "ITP") {
        selectedLoanType = this.rows.filter(
          (sr) => sr.investmentClassID == "ITP" // personal Loan
        );
        return selectedLoanType;
      } else if (this.selectedValue == "TDP") {
        selectedLoanType = this.rows.filter(
          (sr) => sr.investmentClassID == "TDP" // personal Loan
        );
        return selectedLoanType;
      } else if (
        this.selectedValue == "MFD" ||
        this.selectedValue == "AUS" ||
        this.selectedValue == "BNK"
      ) {
        selectedLoanType = this.rows.filter(
          (sr) => sr.investmentClassID == this.selectedValue // Home Loan
        );
        return selectedLoanType;
      } else if (this.selectedValue == "OTH") {
        selectedLoanType = this.rows.filter(
          (sr) =>
            sr.investmentClassID != "ITP" &&
            sr.investmentClassID != "MFD" &&
            sr.investmentClassID != "AUS" &&
            sr.investmentClassID != "TDP" &&
            sr.investmentClassID != "BNK"
          // Others/uncategorized
        );
        return selectedLoanType;
      } else {
        return this.rows;
      }
    },
    loanCategories() {
      let menudata = [];
      if (this.rows.length == 0 || this.rows.length == undefined)
        return menudata;
      menudata.push(this.GetMenuObject("", this.selectedValue, "Recent"));
      menudata.push(
        this.GetMenuObject("ITP", this.selectedValue, "Investment Platforms")
      );
      let investClassMenu = this.rows
        .filter((x) => x.investmentClassID != null)
        .map((r) => {
          let p = {};
          p.id = r.investmentClassID;
          p.value = InvestmentClass[p.id];
          return p;
        });
      if (
        investClassMenu.length > 0 &&
        investClassMenu.filter(
          (sr) => sr.id == "MFD" // personal Loan
        ).length > 0
      ) {
        menudata.push(
          this.GetMenuObject("MFD", this.selectedValue, InvestmentClass.MFD)
        );
      }
      if (
        investClassMenu.length > 0 &&
        investClassMenu.filter(
          (sr) => sr.id == "TDP" // personal Loan
        ).length > 0
      ) {
        menudata.push(
          this.GetMenuObject(
            InvestmentTypeMapping.TDP.key,
            this.selectedValue,
            InvestmentClass.TDP
          )
        );
      }
      if (
        investClassMenu.length > 0 &&
        investClassMenu.filter(
          (sr) => sr.id == "AUS" // personal Loan
        ).length > 0
      ) {
        menudata.push(
          this.GetMenuObject("AUS", this.selectedValue, InvestmentClass.AUS)
        );
      }

      if (
        investClassMenu.length > 0 &&
        investClassMenu.filter(
          (sr) => sr.id == "BNK" // personal Loan
        ).length > 0
      ) {
        menudata.push(
          this.GetMenuObject("BNK", this.selectedValue, InvestmentClass.BNK)
        );
      }

      if (
        investClassMenu.length > 0 &&
        investClassMenu.filter(
          (sr) =>
            sr.id != "MFD" &&
            sr.id != "AUS" &&
            sr.id != "BNK" &&
            sr.id != InvestmentTypeMapping.ITP.key &&
            sr.id != InvestmentTypeMapping.TDP.key
          // personal Loan
        ).length > 0
      ) {
        menudata.push(
          this.GetMenuObject("OTH", this.selectedValue, InvestmentClass.OTH)
        );
      }

      return menudata;
    },
  },
  async created() {
    this.setAllInvestmentInformation([]);
    this.removeEmptyInvestmentInfo();
    await this.mapData();
    //this.loanCategories();
  },
};
</script>
<style></style>
